import React from 'react';
import { motion } from 'framer-motion';
const steps = ['Descarga el manual e identifica tus gatillos de inflamación personales.', 'Aplica el menú de choque "Metabolic Flush" durante 3 días seguidos.', 'Observa cómo desaparece la hinchazón y recuperas tu claridad mental.'];
export const HowItWorks = () => {
  return <section className="py-20 bg-cream-dark" data-id="element-142">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-145">
            Cómo funciona en 3 pasos
          </h2>

          <div className="grid gap-8 md:grid-cols-3" data-id="element-146">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="relative bg-white p-8 rounded-2xl shadow-sm text-center pt-12" data-id="element-147">
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-amber text-white font-serif font-bold text-2xl flex items-center justify-center shadow-md" data-id="element-148">
                  {index + 1}
                </div>
                <p className="text-charcoal-light font-medium leading-relaxed" data-id="element-149">
                  {step}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};